import { render } from "./DefaultLayout.vue?vue&type=template&id=d5784edc"
const script = {}

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/lib/layouts/DefaultLayout.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "d5784edc"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('d5784edc', __exports__)) {
    api.reload('d5784edc', __exports__)
  }
  
  module.hot.accept("./DefaultLayout.vue?vue&type=template&id=d5784edc", () => {
    api.rerender('d5784edc', render)
  })

}


export default __exports__